import { Component } from '@angular/core';
import { environment } from '@ca/environment/environment';
import { ExperimentalFeaturesService } from '../../services/experimental-features.service';

@Component({
    selector: 'ca-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
    isMEDProjectEnabled: boolean = this.experimentalFeaturesService.isMEDProjectActive;

    get landingPageUrl(): string {
        return environment.landingPageUrl;
    }

    get currentYear(): number {
        return new Date().getFullYear();
    }

    constructor(private experimentalFeaturesService: ExperimentalFeaturesService) {}
}
